import { ExportSite } from "constants/exportSites";

import { ExportSiteValidationErrorOrStatusGetter } from "lib/validation/exportSiteValidation";

import { EMPTY_ARRAY } from "lib/index";
import { ErrorDict } from "./doValidate";

type ExportSiteValidationStatus = Record<ExportSite, string | ErrorDict>;

export function advancedDraftingValidation(
  saleLot: SaleLot,
  currentDeploymentSales: Record<string, DeploymentSale>,
  consignments?: Record<string, Consignment>,
  roundByIdLookup?: Record<string, SaleRound>,
): ExportSiteValidationStatus {
  const consignment = consignments[saleLot.consignment_id];
  const emptyValidationStatus = {} as ExportSiteValidationStatus;

  if (!consignment) {
    return emptyValidationStatus;
  }

  const deploymentSale = currentDeploymentSales[consignment?.deployment_sale];

  // We need the consignment available due to our change of selectors, so fudge it in there.
  // Additionally, the round pre-return from server is sale_round_id, but the response has sale_round as a nested object.
  const saleLotWithConsignment = {
    consignment,
    ...saleLot,
    sale_round: saleLot.sale_round || roundByIdLookup[saleLot.sale_round_id],
  };

  const exportSites: ExportSite[] =
    Object.keys(ExportSite).filter(exportSite =>
      Boolean(deploymentSale?.export_sites.find(es => es === exportSite)),
    ) || EMPTY_ARRAY;

  return exportSites.reduce((sites, exportSite) => {
    sites[exportSite] = ExportSiteValidationErrorOrStatusGetter[exportSite](
      saleLotWithConsignment,
    );
    return sites;
  }, {} as ExportSiteValidationStatus);
}
